import { render, staticRenderFns } from "./AdminCityPairs.vue?vue&type=template&id=2216be14"
import script from "./AdminCityPairs.vue?vue&type=script&lang=js"
export * from "./AdminCityPairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports